// 参考博客： https://www.it520.org/2016/11/01/google-analytics-ga/
// 官方文档：https://developers.google.com/analytics/devguides/collection/analyticsjs/creating-trackers?hl=zh-cn

// 谷歌统计媒体资源命名列表
const GAMedias = [
  { name: 'con', UA: '' },
  { name: 'infoq', UA: 'UA-103082599-11' }
]

export default {
  GA: (eType, ...prams) => {
    if (window.ga) {
      for (let media of GAMedias) {
        if (eType === 'create') {
          window.ga(eType, media.UA ? media.UA : prams[0], prams[1], media.name)
        } else {
          window.ga(`${media.name}.${eType}`, ...prams)
        }
      }
    }
  }
}
